export default () =>
  import(/* webpackChunkName: 'coffee/activities/fission/wawa' */ './Wawa');
